/* Método 500 — scripts propios (sin librerías) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.m5-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Compra: casilla de consentimiento obligatoria, carrito limpio y paso directo al pago */
  function initBuy() {
    document.querySelectorAll('[data-m5-buy]').forEach(function (form) {
      var box = form.querySelector('input[type="checkbox"]'); /* solo existe si se activa la casilla en los ajustes */
      var btn = form.querySelector('button[type="submit"]');
      var hint = form.querySelector('.m5-buy__hint');
      if (!btn) return;
      var idleText = hint ? hint.textContent : '';
      function showError() {
        if (hint) { hint.textContent = form.getAttribute('data-error') || ''; hint.classList.add('is-error'); }
      }
      if (box) {
        var sync = function () {
          btn.setAttribute('aria-disabled', box.checked ? 'false' : 'true');
          if (hint && box.checked) { hint.textContent = idleText; hint.classList.remove('is-error'); }
        };
        box.addEventListener('change', sync);
        box.addEventListener('invalid', showError); /* el navegador bloquea el envío por «required» */
        sync();
      }
      form.addEventListener('submit', function (ev) {
        if (box && !box.checked) { ev.preventDefault(); showError(); box.focus(); return; }
        if (!window.fetch) return; /* sin JS moderno: envío normal del formulario */
        ev.preventDefault();
        if (btn.getAttribute('aria-busy') === 'true') return; /* evita el doble envío */
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        var data = new FormData(form);
        var props = {};
        data.forEach(function (v, k) {
          var m = k.match(/^properties\[(.+)\]$/);
          if (m) props[m[1]] = v;
        });
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
          .then(function () {
            return fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(data.get('id')), quantity: 1, properties: props }] })
            });
          })
          .then(function (r) {
            if (!r.ok) throw new Error('add');
            /* Fija la cantidad en 1 aunque la petición se repita (doble clic, red lenta) */
            var upd = {}; upd[Number(data.get('id'))] = 1;
            return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: upd }) });
          })
          .then(function () { window.location.href = root + 'checkout'; })
          .catch(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); form.submit(); });
      });
    });
  }

  function initGallery() {
    var dlg = document.querySelector('[data-m5-lightbox]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var img = dlg.querySelector('img');
    document.querySelectorAll('[data-m5-zoom]').forEach(function (b) {
      b.addEventListener('click', function () {
        img.src = b.getAttribute('data-m5-zoom');
        img.alt = b.getAttribute('data-alt') || '';
        dlg.showModal();
      });
    });
    dlg.querySelector('button').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }

  function initMobileBar() {
    var bar = document.querySelector('[data-m5-mbar]');
    if (!bar) return;
    /* La barra se oculta mientras se ve cualquier bloque de compra (cabecera, precio o cierre) */
    var zones = document.querySelectorAll('[data-m5-hero], [data-m5-cta]');
    var visible = new Set();
    function upd() { var show = visible.size === 0; bar.classList.toggle('is-visible', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true'); }
    if (!zones.length || !('IntersectionObserver' in window)) { bar.classList.add('is-visible'); bar.setAttribute('aria-hidden', 'false'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target); });
      upd();
    });
    zones.forEach(function (z) { visible.add(z); io.observe(z); });
  }

  function initPdpGallery() {
    var main = document.querySelector('[data-m5-pdp-main]');
    if (!main) return;
    document.querySelectorAll('[data-m5-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-m5-thumb');
        main.srcset = t.getAttribute('data-srcset') || '';
        main.alt = t.getAttribute('data-alt') || '';
        document.querySelectorAll('[data-m5-thumb]').forEach(function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
      });
    });
  }

  function initTocMore() {
    document.querySelectorAll('[data-m5-toc-more]').forEach(function (btn) {
      var list = btn.previousElementSibling;
      if (!list) return;
      btn.addEventListener('click', function () {
        var open = list.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      });
    });
  }

  function init() { initReveal(); initBuy(); initGallery(); initMobileBar(); initPdpGallery(); initTocMore(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
